import React from 'react'
import './about.css'
import ME from '../../assets/aboutwala.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Insights</h5>
      <h2>About the channel</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>Educational</h5>
              <small>Tech domains</small>
            </article>
            <article className='about__card'>
              <FiUsers className='about__icon'/>
              <h5>Insightful</h5>
              <small>Eye-catchy videos</small>
            </article>
            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Innovative</h5>
              <small>Unique presentation</small>
            </article>
          </div>
          <br />
          <blockquote>
          Welcome to our electrifying technical YouTube channel! Are you ready to dive into the fascinating world of tech? We've got you covered with informative and engaging videos on everything from web development and programming to cybersecurity and more. Our expert hosts will guide you through the latest trends and advancements, with insider tips and tricks to help you become a true tech wizard. Plus, with our captivating and well-produced content, you won't be able to look away! So, what are you waiting for? Join our community of tech enthusiasts and let's explore the limitless possibilities of technology together! Hit that subscribe button now and let's embark on a journey of digital discovery!




              
          </blockquote>
          <br />
            <a href="#contact" className='btn btn-primary'>Let's Collaborate</a>
        </div>
      </div>
    </section>
  )
}

export default About